module.exports = __webpack_public_path__ + "static/media/icon-message-circle.718f104b.svg";